/**
 * @desc 修改并提交(spu+sku)
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductMasterResponseDto>;
export function request(
  body: defs.basics.ProductMasterRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/updateFullAndCommit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
